app.service('userCache', ['$cacheFactory', function ($cacheFactory) {
	return $cacheFactory('users');
}]);